/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { SvgIcon } from '@mui/material';
import { SvgIconProps } from '@mui/material/SvgIcon';
import { ReactComponent as uploadIcon } from '../../../assets/icons/upload.svg';
import { ReactComponent as addIcon } from '../../../assets/icons/add.svg';
import { ReactComponent as editIcon } from '../../../assets/icons/edit.svg';
import { ReactComponent as publishIcon } from '../../../assets/icons/publish.svg';
import { ReactComponent as removeIcon } from '../../../assets/icons/remove.svg';
import { ReactComponent as deleteIcon } from '../../../assets/icons/delete.svg';
import { ReactComponent as usedIcon } from '../../../assets/icons/used.svg';
import { ReactComponent as unusedIcon } from '../../../assets/icons/unused.svg';
import { ReactComponent as notInUseIcon } from '../../../assets/icons/notInUse.svg';
import { ReactComponent as closeIcon } from '../../../assets/icons/close.svg';
import { ReactComponent as fileDownloadIcon } from '../../../assets/icons/fileDownload.svg';
import { ReactComponent as dashboardIcon } from '../../../assets/icons/dashboard.svg';
import { ReactComponent as profileIcon } from '../../../assets/icons/profile.svg';
import { ReactComponent as downIcon } from '../../../assets/icons/down.svg';
import { ReactComponent as editProfileIcon } from '../../../assets/icons/editProfile.svg';
import { ReactComponent as logoutIcon } from '../../../assets/icons/logout.svg';
import { ReactComponent as versionIcon } from '../../../assets/icons/version.svg';
import { ReactComponent as finalIcon } from '../../../assets/icons/final.svg';
import { ReactComponent as themeIcon } from '../../../assets/icons/theme.svg';
import { ReactComponent as topicIcon } from '../../../assets/icons/topic.svg';
import { ReactComponent as subTopicIcon } from '../../../assets/icons/subTopic.svg';
import { ReactComponent as brandIcon } from '../../../assets/icons/brand.svg';
import { ReactComponent as personIcon } from '../../../assets/icons/person.svg';
import { ReactComponent as identityIcon } from '../../../assets/icons/identity.svg';
import { ReactComponent as locationIcon } from '../../../assets/icons/location.svg';
import { ReactComponent as eventIcon } from '../../../assets/icons/event.svg';
import { ReactComponent as authorIcon } from '../../../assets/icons/author.svg';
import { ReactComponent as assetIcon } from '../../../assets/icons/asset.svg';
import { ReactComponent as vlogIcon } from '../../../assets/icons/vlog.svg';
import { ReactComponent as articleIcon } from '../../../assets/icons/article.svg';
import { ReactComponent as videoIcon } from '../../../assets/icons/video.svg';
import { ReactComponent as blogIcon } from '../../../assets/icons/blog.svg';
import { ReactComponent as quoteIcon } from '../../../assets/icons/quote.svg';
import { ReactComponent as postIcon } from '../../../assets/icons/post.svg';
import { ReactComponent as bookIcon } from '../../../assets/icons/book.svg';
import { ReactComponent as tickIcon } from '../../../assets/icons/tick.svg';
import { ReactComponent as marketingPlatformIcon } from '../../../assets/icons/marketingPlatform.svg';
import { ReactComponent as youtubeIcon } from '../../../assets/icons/youtube.svg';
import { ReactComponent as facebookIcon } from '../../../assets/icons/fb.svg';
import { ReactComponent as instagramIcon } from '../../../assets/icons/insta.svg';
import { ReactComponent as linkedInIcon } from '../../../assets/icons/ln.svg';
import { ReactComponent as twitterIcon } from '../../../assets/icons/twitter.svg';
import { ReactComponent as frontEndAnalyticsIcon } from '../../../assets/icons/frontEndAnalytics.svg';
import { ReactComponent as upIcon } from '../../../assets/icons/up.svg';
import { ReactComponent as searchIcon } from '../../../assets/icons/search.svg';
import { ReactComponent as viewIcon } from '../../../assets/icons/view.svg';
import { ReactComponent as filterIcon } from '../../../assets/icons/filter.svg';
import { ReactComponent as filledDashboardIcon } from '../../../assets/icons/filledDashboard.svg';
import { ReactComponent as filledThemeIcon } from '../../../assets/icons/filledTheme.svg';
import { ReactComponent as filledTopicIcon } from '../../../assets/icons/filledTopic.svg';
import { ReactComponent as filledSubTopicIcon } from '../../../assets/icons/filledSubTopic.svg';
import { ReactComponent as filledBrandIcon } from '../../../assets/icons/filledBrand.svg';
import { ReactComponent as filledPersonIcon } from '../../../assets/icons/filledPerson.svg';
import { ReactComponent as filledIdentityIcon } from '../../../assets/icons/filledIdentity.svg';
import { ReactComponent as filledLocationIcon } from '../../../assets/icons/filledLocation.svg';
import { ReactComponent as filledEventIcon } from '../../../assets/icons/filledEvent.svg';
import { ReactComponent as filledAuthorIcon } from '../../../assets/icons/filledAuthor.svg';
import { ReactComponent as filledAssetIcon } from '../../../assets/icons/filledAssets.svg';
import { ReactComponent as filledBlogIcon } from '../../../assets/icons/filledBlog.svg';
import { ReactComponent as filledArticleIcon } from '../../../assets/icons/filledArticle.svg';
import { ReactComponent as filledVideoIcon } from '../../../assets/icons/filledVideo.svg';
import { ReactComponent as filledVlogIcon } from '../../../assets/icons/filledVlog.svg';
import { ReactComponent as filledQuoteIcon } from '../../../assets/icons/filledQuote.svg';
import { ReactComponent as filledPostIcon } from '../../../assets/icons/filledPost.svg';
import { ReactComponent as filledBookIcon } from '../../../assets/icons/filledBook.svg';
import { ReactComponent as filledMarketingPlatformIcon } from '../../../assets/icons/filledMarketingPlatform.svg';
import { ReactComponent as filledYoutubeIcon } from '../../../assets/icons/filledYoutube.svg';
import { ReactComponent as filledFacebookIcon } from '../../../assets/icons/filledFB.svg';
import { ReactComponent as filledInstagramIcon } from '../../../assets/icons/filledInsta.svg';
import { ReactComponent as filledLinkedInIcon } from '../../../assets/icons/filledLn.svg';
import { ReactComponent as filledTwitterIcon } from '../../../assets/icons/filledX.svg';
import { ReactComponent as filledFrontEndAnalyticsIcon } from '../../../assets/icons/filledFrontEndAnalytics.svg';
import { ReactComponent as filledEditProfileIcon } from '../../../assets/icons/filledEditProfile.svg';
import { ReactComponent as filledLogoutIcon } from '../../../assets/icons/filledLogout.svg';
import { ReactComponent as filledFilterIcon } from '../../../assets/icons/filledFilter.svg';
import { ReactComponent as openEyeIcon } from '../../../assets/icons/openEye.svg';
import { ReactComponent as closeEyeIcon } from '../../../assets/icons/closeEye.svg';

import { makeStyles } from '@mui/styles';
import theme from '../../../core/theme';

const useStyles = makeStyles({
  root: {
    '& g path': {
      fill: ({ fillColor }: { fillColor: string | null | undefined }) => fillColor,
    },
  },
});

interface Props extends SvgIconProps {
  component: React.ElementType;
  // eslint-disable-next-line react/require-default-props
  fillColor?: string | null | undefined;
}

type StyledIconProps = Omit<Props, 'component'>;

function StyledIcon({ fillColor = theme.palette.primary2.main, ...props }: Props) {
  const classes = useStyles({ fillColor });
  const { className, ...otherProps } = props;
  return <SvgIcon {...otherProps} className={`${classes.root} ${className}`} />;
}

export function UploadIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 48 48', fillColor: '', ...props };
  return <StyledIcon component={uploadIcon} {...otherProps} />;
}
export function AddIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 48 48', fillColor: '', ...props };
  return <StyledIcon component={addIcon} {...otherProps} />;
}
export function EditIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 48 48', fillColor: '', ...props };
  return <StyledIcon component={editIcon} {...otherProps} />;
}
export function PublishIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 74 74', fillColor: '', ...props };
  return <StyledIcon component={publishIcon} {...otherProps} />;
}
export function RemoveIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 17 16', fillColor: '', ...props };
  return <StyledIcon component={removeIcon} {...otherProps} />;
}
export function DeleteIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={deleteIcon} {...otherProps} />;
}
export function UsedIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 18 19', fillColor: '', ...props };
  return <StyledIcon component={usedIcon} {...otherProps} />;
}
export function UnusedIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 24 24', fillColor: '', ...props };
  return <StyledIcon component={unusedIcon} {...otherProps} />;
}
export function NotInUseIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 24 24', fillColor: '', ...props };
  return <StyledIcon component={notInUseIcon} {...otherProps} />;
}
export function CloseIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={closeIcon} {...otherProps} />;
}
export function ViewIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={viewIcon} {...otherProps} />;
}
export function FileDownloadIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 12 16', fillColor: '', ...props };
  return <StyledIcon component={fileDownloadIcon} {...otherProps} />;
}
export function DashboardIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={dashboardIcon} {...otherProps} />;
}
export function ProfileIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={profileIcon} {...otherProps} />;
}
export function DownIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={downIcon} {...otherProps} />;
}
export function EditProfileIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={editProfileIcon} {...otherProps} />;
}
export function LogoutIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={logoutIcon} {...otherProps} />;
}
export function VersionIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={versionIcon} {...otherProps} />;
}
export function FinalIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={finalIcon} {...otherProps} />;
}
export function ThemeIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={themeIcon} {...otherProps} />;
}
export function TopicIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={topicIcon} {...otherProps} />;
}
export function SubTopicIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={subTopicIcon} {...otherProps} />;
}
export function BrandIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={brandIcon} {...otherProps} />;
}
export function PersonIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={personIcon} {...otherProps} />;
}
export function IdentityIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={identityIcon} {...otherProps} />;
}
export function LocationIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={locationIcon} {...otherProps} />;
}
export function EventIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={eventIcon} {...otherProps} />;
}
export function AuthorIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={authorIcon} {...otherProps} />;
}
export function AssetIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={assetIcon} {...otherProps} />;
}
export function VlogIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={vlogIcon} {...otherProps} />;
}
export function ArticleIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={articleIcon} {...otherProps} />;
}
export function VideoIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={videoIcon} {...otherProps} />;
}
export function BlogIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={blogIcon} {...otherProps} />;
}
export function QuoteIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={quoteIcon} {...otherProps} />;
}
export function PostIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={postIcon} {...otherProps} />;
}
export function BookIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={bookIcon} {...otherProps} />;
}
export function TickIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={tickIcon} {...otherProps} />;
}
export function MarketingPlatformIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={marketingPlatformIcon} {...otherProps} />;
}
export function YoutubeIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={youtubeIcon} {...otherProps} />;
}
export function FacebookIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={facebookIcon} {...otherProps} />;
}
export function InstagramIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={instagramIcon} {...otherProps} />;
}
export function LinkedInIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={linkedInIcon} {...otherProps} />;
}
export function TwitterIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={twitterIcon} {...otherProps} />;
}
export function FrontEndAnalyticsIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={frontEndAnalyticsIcon} {...otherProps} />;
}
export function UpIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={upIcon} {...otherProps} />;
}
export function SearchIcon(props: StyledIconProps) {
  const otherProps = { fillColor: '', ...props };
  return <StyledIcon component={searchIcon} {...otherProps} />;
}
export function FilterIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 40 40', fillColor: '', ...props };
  return <StyledIcon component={filterIcon} {...otherProps} />;
}
export function FilledDashboardIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={filledDashboardIcon} {...otherProps} />;
}
export function FilledThemeIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={filledThemeIcon} {...otherProps} />;
}
export function FilledTopicIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={filledTopicIcon} {...otherProps} />;
}
export function FilledSubTopicIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={filledSubTopicIcon} {...otherProps} />;
}
export function FilledBrandIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={filledBrandIcon} {...otherProps} />;
}
export function FilledPersonIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={filledPersonIcon} {...otherProps} />;
}
export function FilledIdentityIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={filledIdentityIcon} {...otherProps} />;
}
export function FilledLocationIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={filledLocationIcon} {...otherProps} />;
}
export function FilledEventIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={filledEventIcon} {...otherProps} />;
}
export function FilledAuthorIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={filledAuthorIcon} {...otherProps} />;
}
export function FilledAssetIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={filledAssetIcon} {...otherProps} />;
}
export function FilledVlogIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={filledVlogIcon} {...otherProps} />;
}
export function FilledArticleIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={filledArticleIcon} {...otherProps} />;
}
export function FilledVideoIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={filledVideoIcon} {...otherProps} />;
}
export function FilledBlogIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={filledBlogIcon} {...otherProps} />;
}
export function FilledQuoteIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={filledQuoteIcon} {...otherProps} />;
}
export function FilledPostIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={filledPostIcon} {...otherProps} />;
}
export function FilledBookIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={filledBookIcon} {...otherProps} />;
}
export function FilledMarketingPlatformIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={filledMarketingPlatformIcon} {...otherProps} />;
}
export function FilledYoutubeIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={filledYoutubeIcon} {...otherProps} />;
}
export function FilledFacebookIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={filledFacebookIcon} {...otherProps} />;
}
export function FilledInstagramIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={filledInstagramIcon} {...otherProps} />;
}
export function FilledLinkedInIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={filledLinkedInIcon} {...otherProps} />;
}
export function FilledTwitterIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={filledTwitterIcon} {...otherProps} />;
}
export function FilledFrontEndAnalyticsIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={filledFrontEndAnalyticsIcon} {...otherProps} />;
}
export function FilledEditProfileIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={filledEditProfileIcon} {...otherProps} />;
}
export function FilledLogoutIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 42 42', fillColor: '', ...props };
  return <StyledIcon component={filledLogoutIcon} {...otherProps} />;
}
export function FilledFilterIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 40 40', fillColor: '', ...props };
  return <StyledIcon component={filledFilterIcon} {...otherProps} />;
}
export function OpenEyeIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 40 40', fillColor: '', ...props };
  return <StyledIcon component={openEyeIcon} {...otherProps} />;
}
export function CloseEyeIcon(props: StyledIconProps) {
  const otherProps = { viewBox: '0 0 40 40', fillColor: '', ...props };
  return <StyledIcon component={closeEyeIcon} {...otherProps} />;
}
